<template>
  <div style="padding:10px;overflow:auto;height:80vh">
    <el-container>
      <el-header height="6vh">
        <el-button-group>
          <el-button type="primary" icon="el-icon-plus" @click="handleAdd()">添加</el-button>
        </el-button-group>
      </el-header>
      <el-main>
        <el-table ref="multipleTable" :data="datalist" style="width: 100%" height="68vh">
          <el-table-column label="序号" width="50" type="index" fixed></el-table-column>
          <el-table-column label="标题" prop="title"></el-table-column>
          <el-table-column label="添加时间" prop="addTime" width="150"></el-table-column>
          <el-table-column fixed="right" label="操作" width="200">
            <template slot-scope="scope">
              <el-button
                type="primary"
                icon="el-icon-edit"
                size="mini"
                @click="handleEdit(scope.row)"
              ></el-button>
              <el-button
                type="danger"
                icon="el-icon-delete"
                size="mini"
                @click="handleDelete(scope.row)"
              ></el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 添加修改区 开始 -->
        <add-t v-if="addShow" :Content="datainfo" @hide="hideAdd" @refresh="fetchData"></add-t>
        <edit-t v-if="editShow" :Content="datainfo" @hide="hideEdit" @refresh="fetchData"></edit-t>
      </el-main>
    </el-container>
  </div>
</template>
<script>
import {
  getList,
  deleteSingle as deleteContent,
  getSingle as getContent
} from "../../../api/gm/api-single";
import AddT from "./add";
import EditT from "./edit";
export default {
  //..数据
  data() {
    return {
      addShow: false, //添加框的显示与隐藏
      editShow: false, //修改框显示与隐藏
      datalist: [], //列表信息
      datainfo: {
        id: 0,
        title: "",
        info: ""
      }
    };
  },
  components: {
    "add-t": AddT,
    "edit-t": EditT
  },
  created() {
    this.fetchData();
  },
  //..方法
  methods: {
    //..获取列表数据
    fetchData() {
      this.datalist = [];
      getList().then(res => {
        //获取产品
        if (res.code === 0) {
          this.datalist = res.data;
        } else {
          console.log(res.msg);
        }
      });
    },
    //..弹出添加框
    handleAdd() {
      this.datainfo.id = 0;
      this.datainfo.title = "";
      this.datainfo.info = "";
      this.addShow = true;
    },
    //..隐藏添加框
    hideAdd() {
      this.addShow = false;
    },

    //..弹出编辑框
    handleEdit(row) {
      getContent(row.id).then(res => {
        if (res.code === 0) {
          this.datainfo.id = res.data.id;
          this.datainfo.title = res.data.title;
          this.datainfo.info = res.data.info;
          this.editShow = true;
        } else {
          console.log(res.msg);
        }
      });
    },
    //..隐藏修改框
    hideEdit() {
      this.editShow = false;
    },
    //..删除
    handleDelete(row) {
      this.$confirm("删除不可恢复,确认?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        lockScroll: false
      })
        .then(() => {
          deleteContent(row.id).then(res => {
            if (res.code === 0) {
              this.fetchData();
              this.$notify.success({
                title: "成功",
                message: "删除成功",
                duration: 1500
              });
            } else {
              this.$notify.error({
                title: "失败",
                message: "删除失败",
                duration: 1500
              });
            }
          });
        })
        .catch(() => {});
    }
  }
};
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/pages/gm/single/index.vue